import Input from 'components/Form/LabelInput'
import BtnOrange from 'components/Button/BtnBlue'
import Messages from 'components/Messages'
import Spinner from 'components/Spinner'
import { Login, SubTitle, InputBox, BtnBox, Form } from './styled'

const Component = ({ formik, messages, data }) => {
  return (
    <Login>
      <h1>Esqueci a senha</h1>
      <SubTitle>Informe seu email cadastrado e enviaremos um link para que posso redefinir sua senha.</SubTitle>
      <Form onSubmit={formik.handleSubmit}>
        <Messages formMessages={messages.messages} alert={messages.alert} />
        <InputBox>
          <Input
            labelColor="var(--color-green)"
            type="email"
            name="email"
            label="Seu email*"
            formik={formik}
          />
        </InputBox>
        <BtnBox>
          <BtnOrange style={{ backgroundColor: data ? data.secondary_color : "var(--color-yellow)" }} type="submit" disabled={formik.isSubmitting}>
            {formik.isSubmitting ? <Spinner /> : "Entrar"}
          </BtnOrange>
          </BtnBox>
      </Form>
    </Login>
  )
}

export default Component